import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import Button from "components/Button";
import Dialog, { CloseDialog } from "components/Dialog";
import Dropdown from "components/Dropdown";

import { useStateSelector } from "utils/field";
import { useOutsideClickHook } from "utils/outsideClick";

import classes from "./styles.module.scss";
import Delete from "assets/images/icons/JSX/Delete";

const ZoneActions = ({ change, zoneId }) => {
    const ref = useOutsideClickHook(() => toggleMenuOpen(false));
    
    const coolingZones = useStateSelector(`model.modelData.coolingZones`) || {};

    const [menuOpen, toggleMenuOpen] = useState(false);
    const [deleteDialogOpen, toggleDeleteDialog] = useState(false);

    const handleDeleteZone = () => {
        const updatedCoolingZones = { ...coolingZones };
        delete updatedCoolingZones[zoneId];
        change(`model.modelData.coolingZones`, updatedCoolingZones);
    };

    return (
        <div className={classes.actions} ref={ref}>
            <div className={classes.menu}>
                <div className={classes.dots} onClick={() => toggleMenuOpen(!menuOpen)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <Dropdown
                    className={classes.dropDown}
                    open={menuOpen}
                    toggleOpen={toggleMenuOpen}
                    options={[
                        {
                            label: (
                                <span>
                                    <Delete /> Delete
                                </span>
                            ),
                            className: classes.delete,
                            onClick: () => toggleDeleteDialog(true),
                        },
                    ]}
                />
            </div>
            <Dialog open={deleteDialogOpen}>
                <CloseDialog closeActions={() => toggleDeleteDialog(false)} />
                <div className={classes.dialog}>
                    <h3>Are you sure you want to delete this cooling zone?</h3>
                    <div className={classes.footer}>
                        <Button type="hollow" onClick={() => toggleDeleteDialog(false)}>
                            Cancel
                        </Button>
                        <Button onClick={handleDeleteZone} type="red">
                            Delete
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ZoneActions);
